import { render, staticRenderFns } from "./ModelDisplay.vue?vue&type=template&id=29e0a527&scoped=true&"
import script from "./ModelDisplay.vue?vue&type=script&lang=js&"
export * from "./ModelDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ModelDisplay.vue?vue&type=style&index=0&id=29e0a527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e0a527",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer,VFlex,VLayout})
